var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 64.5C14.46 64.5 0 50.04 0 32.25C0 14.46 14.46 0 32.25 0C50.04 0 64.5 14.46 64.5 32.25C64.5 50.04 50.04 64.5 32.25 64.5ZM32.25 4.5C16.95 4.5 4.5 16.95 4.5 32.25C4.5 47.55 16.95 60 32.25 60C47.55 60 60 47.55 60 32.25C60 16.95 47.55 4.5 32.25 4.5Z",
    fill: "url(#paint0_linear_1483_16157)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9903 42.9908C27.3903 42.9908 26.8203 42.7508 26.4003 42.3308L17.9103 33.8408C17.0403 32.9708 17.0403 31.5308 17.9103 30.6608C18.7803 29.7908 20.2203 29.7908 21.0903 30.6608L27.9903 37.5608L43.4103 22.1408C44.2803 21.2708 45.7203 21.2708 46.5903 22.1408C47.4603 23.0108 47.4603 24.4508 46.5903 25.3208L29.5803 42.3308C29.1603 42.7508 28.5903 42.9908 27.9903 42.9908Z",
    fill: "url(#paint1_linear_1483_16157)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1483_16157",
    x1: 32.25,
    y1: 0,
    x2: 32.25,
    y2: 64.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43E355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43D0E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1483_16157",
    x1: 32.2503,
    y1: 0.000780032,
    x2: 32.2503,
    y2: 64.5008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3FFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81D5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.d54cb527cc0723debe2d14bbab925c8c.svg";
export { ForwardRef as ReactComponent };